import { useQuery } from "@apollo/react-hooks";
import { RealEstateQuery } from "./graphql/RealEstateQuery";
import { REAL_ESTATE_QUERY } from "./Queries";

export const GetRealEstates = () => useQuery<RealEstateQuery>(REAL_ESTATE_QUERY);
